import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import Modal from '../../../../common/modal/Modal';
import ManualRelocationCargoItemForm from './ManualRelocationCargoItemForm';
import { putAssignCargoItemToShelfSpace } from '../../../../../actions';

const ManualRelocationCargoItemButton = ({
  location,
  dispatchPutAssignCargoItemToShelfSpace,
  onHandleClear,
}) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);

  const onCloseModal = () => {
    setShowModal(false);
    onHandleClear();
  };

  const onSubmit = async (formValues) => {
    const { items, shelfSpace } = formValues;

    if (!items || items.length === 0) {
      toastr.warning(
        'Advertencia',
        'Debe seleccionar al menos un item para reubicar',
      );
      return;
    }

    if (!shelfSpace) {
      toastr.warning(
        'Advertencia',
        'Debe seleccionar un espacio de estante para reubicar',
      );
      return;
    }

    const payload = {
      cargoItemIds: items,
      shelfSpaceId: shelfSpace.value,
    };

    await dispatchPutAssignCargoItemToShelfSpace(payload);
    onCloseModal();
    onHandleClear();
  };

  const body = (
    <ManualRelocationCargoItemForm
      onSubmit={onSubmit}
      initialValues={{
        location: {
          value: location.value,
          label: location.label,
        },
      }}
    />
  );

  return (
    <>
      <Modal
        show={showModal}
        title="Reubicar Encomiendas Manualmente"
        size="xl"
        body={body}
        onClickClose={() => onCloseModal()}
        onClickCancel={() => onCloseModal()}
      />
      <Button color="success" onClick={openModal}>
        <i className="fa fa-plus-circle" /> Reubicar Manualmente
      </Button>
    </>
  );
};

ManualRelocationCargoItemButton.propTypes = {
  location: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }).isRequired,
  dispatchPutAssignCargoItemToShelfSpace: PropTypes.func.isRequired,
  onHandleClear: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPutAssignCargoItemToShelfSpace: putAssignCargoItemToShelfSpace,
};

export default connect(
  null,
  mapDispatchToProps,
)(ManualRelocationCargoItemButton);
